<div class="flex justify-center h-20 bg-white header">
  <nav class="flex flex-row flex-grow items-stretch px-4 py-3 md:container">
    <ng-container *ngIf="data$ | async as toolbarData">
      <div class="flex flex-grow items-center">
        <div class="flex items-center space-x-3">
          <img
            class="inline-block w-32"
            [src]="
              logoLoadingFailed
                ? 'assets/img/billtech_logo.svg'
                : cdnAddress + '/assets/img/brand/' + (toolbarData.payment?.brandId || toolbarData.brand) + '.png'
            "
            (error)="logoLoadingFailed = true"
            i18n-alt
            alt="BillTech"
          />
          <img src="assets/img/platnosci.png" alt="Płatności" class="w-20" />
        </div>
      </div>

      <app-payment-type-toggle
        *ngIf="toolbarData.typeToggleVisible"
        [payment]="toolbarData.payment"
        [paymentType]="toolbarData.paymentType"
        (typeChange)="changeType($event)"
      >
      </app-payment-type-toggle>

      <div *ngIf="toolbarData.paymentSummary" class="hidden md:flex flex-row items-stretch rounded bg-gray-100 pl-4">
        <div class="flex flex-row items-center justify-between mr-4">
          <div class="flex flex-col w-48 mr-2">
            <div class="flex flex-row space-x-1 text-xs leading-tight">
              <div class="text-gray-700">Płatnik:</div>
              <div class="text-gray-900 truncate">
                {{ toolbarData.personalData.name }} {{ toolbarData.personalData.surname }}
              </div>
            </div>

            <div class="flex flex-row space-x-1 text-xs leading-tight">
              <div class="text-gray-700">Odbiorca:</div>
              <div class="text-gray-900 truncate">{{ toolbarData.paymentSummary.biller }}</div>
            </div>

            <div class="flex flex-row space-x-1 text-xs leading-tight">
              <div class="text-gray-700">Tytuł:</div>
              <div class="text-gray-900 truncate">{{ toolbarData.paymentSummary.title }}</div>
            </div>
          </div>

          <div class="flex flex-col items-end">
            <div class="text-xs text-gray-700">Kwota do zapłaty:</div>
            <div class="text-md leading-none text-gray-900 font-semibold">
              {{ toolbarData.paymentSummary.totalAmount | currency: 'PLN':'code':'.2-2':'pl-PL' }}
            </div>
          </div>
        </div>

        <div class="flex flex-row items-center rounded bg-primary-100 px-4">
          <div class="text-xxs leading-tight font-semibold text-primary-600 pr-6">KARTA<br />PŁATNICZA</div>

          <img src="assets/img/credit_cards.png" alt="Karta płatnicza" class="h-1/3" />
        </div>
      </div>
    </ng-container>
  </nav>
</div>
